import { download,cancelDownload } from '@/api/home'
import axios from 'axios';
import moment from 'moment';
const downloadMixin = {
    props: {},
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    created() {},
    methods: {
        downLoadeHandle(row){
            let fileName = `${row.name}_${moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss')}.xlsx`;
            console.log(fileName,'4444')
            download({taskID:row.id}).then(res=>{
                this.dowloadFile(res.url,fileName)
                this.newTaskData.forEach(item=>{
                    if(item.id === row.id ){
                        item.downloadTimes =res.downloadTimes 
                    }
                })
            })
        },
        // 取消下载
        cancelDownloadHandle(row){
            cancelDownload({taskId:row.id}).then(res=>{
                this.$message.success('取消下载成功')
            }).catch(err=>{
                this.$message.error(err)
            })
        },
        // 下载文件防范
        dowloadFile(url, fileName) {
            // 该方法可以不然浏览器打开新的标签
            // const token = localStorage.getItem('token')
            axios({
                method: 'get',
                url,
                responseType: 'blob',
            }).then((res) => {
                const dataInfo = res.data;
                const blob = new Blob([dataInfo],{ type: dataInfo.type});
                // 转换成blob类型的url
                const blobUrl = URL.createObjectURL(blob);
                const eLink = document.createElement('a');
                eLink.style.display = 'none';
                eLink.href = blobUrl;
                // 设置 下载文件的文件名称, 这里必须要带文件格式
                eLink.download = fileName;
                document.body.appendChild(eLink);
                eLink.click();
                URL.revokeObjectURL(eLink.href); // 释放URL 对象
                document.body.removeChild(eLink);
            });
        }
    },
};

export default downloadMixin;